webpackJsonp([5],{

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLICK_EVENT */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export SELECTORS */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Expands and collapses the overflow items within a personalized product section.
 * A landing page renders one section per recommendation set, so the handler is
 * delegated and scoped to the closest section rather than bound to a single id.
 * @module productSectionViewMore
 */


var CLICK_EVENT = 'click';
var ACTIVE_CLASS = 'is-active';
var SELECTORS = {
  section: '.product-sections',
  button: '.js-productsection-viewmore',
  items: '.js-viewmore-items'
};
var LABEL_ATTRIBUTES = {
  expand: 'data-label-expand',
  collapse: 'data-label-collapse'
};

/**
 * Binds the view more/less toggle for every product section under a container.
 * @param {string|HTMLElement} [container] - Scope to delegate from, defaults to
 * the document so sections added after init are still covered
 */
function init(container) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container || document).on(CLICK_EVENT, SELECTORS.button, buttonClickHandler);
}

/**
 * Toggles the overflow items belonging to the clicked button's section.
 * @param {jQuery.Event} evt - A jQuery event
 */
function buttonClickHandler(evt) {
  evt.preventDefault();
  var $button = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  var $items = $button.closest(SELECTORS.section).find(SELECTORS.items);
  if (!$items.length) {
    return;
  }

  // The class is the source of truth for the current state -- reading :visible
  // is unreliable while a previous slide is still animating.
  var isExpanded = $button.hasClass(ACTIVE_CLASS);
  $button.toggleClass(ACTIVE_CLASS, !isExpanded);
  $button.attr('aria-expanded', !isExpanded);
  $button.text(isExpanded ? $button.attr(LABEL_ATTRIBUTES.expand) : $button.attr(LABEL_ATTRIBUTES.collapse));
  $items.stop(true, true).slideToggle();
}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_product_section_view_more__ = __webpack_require__(200);




__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-revieve-full-look').on('click', function (e) {
    e.preventDefault();
    if (window.rcProps.activeRevievePlugin === 'FULL_LOOK') {
      openPlugin();
    } else {
      window.activateRevieveFullLook(openPlugin);
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_revieve_try_on__["a" /* revieveAddToBag */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */])('#main-content', '.js-favorite-button');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_product_section_view_more__["a" /* default */])('#main-content');
});
function openPlugin() {
  Revieve.API.show();
  logEngagement(window.location.href, 'VTO', 'Open');
}

/***/ })

},[224]);


// WEBPACK FOOTER //
// dist/landing.js